import { Title } from '@angular/platform-browser';

import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from '../test-step/confirmation-dialog.service';
import { ProjectService } from '../../_services/project.service';
import { UserMgmtService } from '../../_services/user-mgmt.service';
import { UserService } from '../../_services/user.service';
import { map, find, switchMap } from 'rxjs/operators';
import { ProjectData } from '../../_models/project-data';
import { environment } from 'src/environments/environment';
import * as _ from "lodash";
import { UrlService } from 'src/app/_services/url.service';
import { MemoryService } from 'src/app/_services/memory.service';
import { HomeService } from 'src/app/_services/home.service';

@Component({
  selector: 'app-run-management',
  templateUrl: './run-management.component.html',
  styleUrls: ['./run-management.component.scss']
})
export class RunManagementComponent implements OnInit {

  checkProjectTree: boolean = false;
  moduleData: any = [];
  projectId: string;
  projectData: any;
  url: string;
  testTreedata: any;
  testTreedataDir: any;
  disableplus: boolean = true;
  disableminus: boolean = false;
  disableplus2: boolean = true;
  disableplus3: boolean = true;
  disableminus2: boolean = false;
  disableminus3: boolean = false;
  TreeData: any[];
  frequencyOptions = ['Daily', 'Weekly', 'Minutes'];
  databaseDrivers = ["MongoDriver", "MySQLDriver", "SQLServerDriver", "SQLServerDriverWA","SQLServerDriverAAD", "InfluxDriver", "OracleDriver", "DB2Driver", "CassandraDriver", "HanaDriver", "SnowflakeServerDriver", "AzureSynpaseDriver"];
  settingForm: UntypedFormGroup;
  editSettingForm: UntypedFormGroup;
  isActiveTab = false;
  isActive = [{
    active: true
  }, {
    active: false
  }];
  headerOptions = {
    showSetting : true,
    showSearch: false,
    heading : 'Run Management',
    data: undefined,
  }


  // isActive[0].active = true;

  checkFreType = function (type) {
    if (type) {
      if (type === 'Daily' || type === 'Minutes') {
        return true;
      } else {
        return false;
      }


    } else {
      return true;
    }

  };


  days = [
    { value: '0', text: 'Sunday' },
    { value: '1', text: 'Monday' },
    { value: '2', text: 'Tuesday' },
    { value: '3', text: 'Wednesday' },
    { value: '4', text: 'Thursday' },
    { value: '5', text: 'Friday' },
    { value: '6', text: 'Saturday' }
  ];

  dayConvert = {
      0: 'Sunday', 
      1: 'Monday',
      2: 'Tuesday', 
      3: 'Wednesday', 
      4: 'Thursday',
      5: 'Friday',
      6: 'Saturday'
    }

  times = [
    { value: '0', text: '12.00 AM' },
    { value: '1', text: '1.00 AM' },
    { value: '2', text: '2.00 AM' },
    { value: '3', text: '3.00 AM' },
    { value: '4', text: '4.00 AM' },
    { value: '5', text: '5.00 AM' },
    { value: '6', text: '6.00 AM' },
    { value: '7', text: '7.00 AM' },
    { value: '8', text: '8.00 AM' },
    { value: '9', text: '9.00 AM' },
    { value: '10', text: '10.00 AM' },
    { value: '11', text: '11.00 AM' },
    { value: '12', text: '12.00 PM' },
    { value: '13', text: '1.00 PM' },
    { value: '14', text: '2.00 PM' },
    { value: '15', text: '3.00 PM' },
    { value: '16', text: '4.00 PM' },
    { value: '17', text: '5.00 PM' },
    { value: '18', text: '6.00 PM' },
    { value: '19', text: '7.00 PM' },
    { value: '20', text: '8.00 PM' },
    { value: '21', text: '9.00 PM' },
    { value: '22', text: '10.00 PM' },
    { value: '23', text: '11.00 PM' }
  ];
  bugLoggingSystem = [
    { value: '', text: '' },
    { value: 'JIRA', text: 'JIRA' },
    { value: 'TFS', text: 'TFS' },
    { value: 'BUGZILLA', text: 'BUGZILLA' },
    { value: 'GITLAB', text: 'GITLAB' },
    { value: 'TFS_PAT', text: 'TFS_PAT' }
  ];


  bugLoggingOption = [{
    value: 'Auto',
    text: 'Auto'
  }, {
    value: 'SemiAuto',
    text: 'SemiAuto'
  }, {
    value: 'Manual',
    text: 'Manual'
  }];
  databaseDriverOptions = ['MySQLDriver', 'SQLServerDriver', 'SQLServerDriverWA','SQLServerDriverAAD', 'MongoDriver', 'OracleDriver', 'DB2Driver', 'CassendraDriver', 'HanaDriver'];

  browserOptions = ['CHROME', 'IE', 'FIREFOX', 'MICROSOFTEDGE', 'SAFARI', 'CHROMEHEADLESS', 'PHANTOMJS', 'OPERA', 'CHROMEEMBEDDED'];

  accessOptions = ['PUBLIC', 'PRIVATE'];
  //filePattern = localStorage.getItem('filePattern');
  filePattern = '^[^:|*?<>/\\-"]+$'

  selectedRunSettingIndex = -1;
  selectedRunSetting = undefined;
  runSetting = new Object();
  // runSetting.name = undefined;
  runSettings = new Array();
  isButtonDisable = true;
  disableRunSetting = true;
  selectedTestSuiteDirData = new Object();
  selectedNode = undefined;
  selectedTreeData = undefined;
  includeTreeData = new Array();
  createIncludeTreeData = new Array();
  treeType = '';
  isopen = "false";

  Obj: any;
  webRunSettings: any;
  webRunSettings4: any;
  dbSettingData: any;
  desktopSettingData: any;
  mobileSettingData: any;
  customSettingData: any;
  globalSettingData: any;
  testEnvSettingData: any;
  settingDataById: any;
  testEnvData: any;
  customData: any;
  appData: any;
  dbData: any;
  webrunSettingLenth: any;
  ObjforAdd: any;
  dataforAdd: [];
  selectedAccessor: string = '';
  selectedTime: any;
  selectedDay: any;
  selectedFrequency: any;
  selectedSchedule: boolean = false;
  projectdataById: any;
  projectdata: any;
  projectSettingData: any;
  testEnvDataSettingData: any;
  applicationSettingData: any;
  customSettingDataforUpdate: any;
  dbSettingDataforUpdate: any;
  selectedSettingTab: number = 0;
  selectedExecutionPlanId: number;
  settingName: string = ''
  executionPlanIndex: number;
  testCaseTreeData: any = [];
  // testcaseList: any=[];
  testCaseList: any = [];
  testcaseTreeList: any = [];

  webrunsettingtestcaseload: any;
  webrunsettingdata: any[] = [];
  dataArray: any[] = []

  WebcheckProjectTree: boolean = false;
  selectedSettingId: string;
  @ViewChild('cancelEditSettingModal', null) cancelEditSettingModal: ElementRef;
  @ViewChild('createRunSettingTab', null) createRunSettingTab: ElementRef;
  currentUrl: any;
  previousUrl: any=[];
  previousUrltemp: any;
  executionPlanName: any;
  agentCheck: boolean;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private project: ProjectService,
    private formBuilder: UntypedFormBuilder,
    private usermgmt: UserMgmtService,
    private toastrService: ToastrService,
    private cookieService: CookieService,
    private router: Router,
    private http: HttpClient,
    private urlService: UrlService,
    private confirmationDialogService: ConfirmationDialogService,
    private memoryService: MemoryService,
    private homeService: HomeService,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.url = environment.baseUrl;
  }

  loadRunSetting = function () {

    this.project.loadRunSettings(this.projectId).subscribe((data) => {

      if (data) {
        this.webRunSettings4 = data['webRunSetting'];
        this.isButtonDisable = false;
        this.disableRunSetting = false;
      } else {
        this.disableRunSetting = true;
      }

      // this.webrunSettingLenth = this.webRunSettings4.length;
      //console.log('webRunSetting', this.webRunSettings4);
      this.initSetting();
      // this.testcaseTreeList = this.webRunSettings4;

    });

    this.isDisable = function () {
      if (this.webRunSettings4 && this.webRunSettings4.length > 0) {
        this.isButtonDisable = false;
      }
    }





  };


  loadSettingTestCase(name) {
    //console.log('name', name);
    this.webrunsettingtestcaseload = this.webRunSettings4.filter((f) => f.settingName == name);
    this.testCaseTreeData = this.webrunsettingtestcaseload[0].selectedTestSuiteDirData.testSuiteDirData[0].testSuiteDirData[0].testCaseData;
    //console.log('filter web run settings', this.testCaseTreeData);
  }

  loadSettingTestCases(testSuiteDirData, testSuiteFileData) {
    //console.log('this.testTreedata', this.testTreedata);

    //console.log('this.testTreedataDir', this.testTreedataDir);
    //console.log('this.testSuiteDirData', testSuiteDirData);
    //console.log('this.testSuiteFileData', testSuiteFileData);
    this.http.get(this.url + '/HuLoopRest/huloop/test/testSuiteData/' + this.projectId + '/' + testSuiteFileData.id).subscribe(
      data => {
        this.testCaseTreeData = data['testCaseData'];
        //console.log('testCaseTreeData', this.testCaseTreeData);
        this.projectdata[0].testTreedata.forEach(element => {
          if (element.id === testSuiteDirData.id) {
            //console.log('testSuiteDirId', testSuiteDirData.id);

            element.items.forEach(element => {
              if (element.id === testSuiteFileData.id) {
                var testCaseData = testSuiteFileData['testCaseData'];
                //console.log('testCaseData', testCaseData);

             
                  this.testCaseTreeData.forEach(element => {
                    testCaseData.forEach(checkedData => {
                      if(element.id == checkedData.id)
                      {
                        element.webChecked = true;
                      }
                    });
                });

                // let uncheckedData = this.testCaseTreeData.filter(o1 => !testCaseData.some(o2 => o1.id === o2.id));
                // let checkedData = testCaseData.filter(o1 => this.testCaseTreeData.some(o2 => o1.id === o2.id));
                // checkedData.forEach(e => {
                //   e.webChecked = true;
                // })

                // uncheckedData.push(...checkedData);

                // //console.log('uncheckedData', uncheckedData);

                element.testCases = this.testCaseTreeData;
              }
            });
          }
        });
      }
    )
  }
  loadSetting(name) {
    //console.log('name', name, "setting : ", this.projectdata);
    this.settingName = name;
    let testSuiteDirData: any;
    let moduleData1: any;
    let testSuiteFileData: any;
    let testCaseData: any;

    var executionPlanList;
    if (this.webRunSettings4) {
      this.webrunsettingtestcaseload = this.webRunSettings4.filter((f) => f.settingName == name);
      //console.log('webrunsettingdata', this.webrunsettingdata = this.webrunsettingtestcaseload[0]);
      executionPlanList = this.webrunsettingtestcaseload[0].executionPlanList;
    }

    for (let i = 0; i < executionPlanList.length; i++) {
      if (i == 0) {
        this.getExecutionPlan(executionPlanList[i], i)
      }

    }
    var data = {} = this.webrunsettingtestcaseload[0];
    //console.log('this.webrunsettingtestcaseload', data);
    if (data != undefined) {
      //console.log('inside if data', data);
      var selectedTestSuiteDirData = data['selectedTestSuiteDirData'];
      if (selectedTestSuiteDirData != undefined && selectedTestSuiteDirData.selectedState === "INDETERMINATE") {
        this.WebcheckProjectTree = false;
        this.webCheckProject(this.WebcheckProjectTree);

        if (selectedTestSuiteDirData['testSuiteDirData']) {
          selectedTestSuiteDirData['testSuiteDirData'].forEach(moduleData => {
            testSuiteDirData = moduleData;

            if (testSuiteDirData != undefined && testSuiteDirData.selectedState === "INDETERMINATE") {

              testSuiteDirData['testSuiteFileData'].forEach(suiteData => {
                testSuiteFileData = suiteData;
                //console.log('testSuiteFileData', testSuiteFileData);
                if (testSuiteFileData != undefined && testSuiteFileData.selectedState === "INDETERMINATE") {
                  testCaseData = testSuiteFileData['testCaseData'];
                  testSuiteFileData['testCaseData'].forEach(testCaseDetails => {
                    if (testCaseDetails != undefined && testCaseDetails.selectedState === "SELECTED") {
                      this.webCheckTestCase(true, moduleData.id, suiteData.id, testCaseDetails.id);
                    }
                  })
                  //console.log('testSuiteDirData', testSuiteDirData);

                  // moduleData1 = this.moduleData[0];
                  // //console.log('moduleData1', moduleData1);
                  // this.WebcheckProjectTree = false;
                  // if (moduleData1.items != undefined) {
                  //   this.moduleData[0].items.forEach(e => {
                  //     e.webChecked = false;
                  //     //console.log('e', e);
                  //   });
                  //   let title = moduleData1.title;
                  //   let mainTitle;
                  //   if(title.length > 1)
                  //   {
                  //     mainTitle = title.replaceAll(",", "");
                  //   }
                  // this.webCheckTestSuite(false, mainTitle, moduleData1.items[0].id);
                  //  }

                  this.loadSettingTestCases(testSuiteDirData, testSuiteFileData);
                }
                else {
                  this.webCheckTestSuite(true, moduleData.id, suiteData.id);
                }
              });
            }
            else {

              this.checkWebModule(true, moduleData)
              moduleData1 = this.moduleData[0];
              if (moduleData1.items != undefined) {
                this.moduleData.forEach(e => {
                  if (e.id === moduleData.id) {
                    e.webChecked = true;
                  }
                });
              }

              //console.log('module level select', moduleData1);
            }

          });
        }

        if (selectedTestSuiteDirData['testSuiteFileData']) {
          selectedTestSuiteDirData['testSuiteFileData'].forEach(outerSuiteData => {

            testSuiteFileData = outerSuiteData;
            //console.log('testSuiteFileData', testSuiteFileData);
            if (testSuiteFileData != undefined && testSuiteFileData.selectedState === "INDETERMINATE") {
              testCaseData = testSuiteFileData['testCaseData'];

              testSuiteFileData['testCaseData'].forEach(outerTestSuiteData => {
                this.webCheckOuterTestCase(true, outerSuiteData.id, outerTestSuiteData.id)
              });

              // //console.log('testSuiteDirData', testSuiteDirData);
              // moduleData1 = this.moduleData[0];
              // //console.log('moduleData1', moduleData1);
              // this.WebcheckProjectTree = false;
              // if (moduleData1.items != undefined) {
              //   this.moduleData[0].items.forEach(e => {
              //     e.webChecked = false;
              //     //console.log('e', e);
              //   });
              //     this.webCheckTestSuite(false, ',', moduleData1.items[0].id);
              // }
              // this.WebcheckProjectTree = false;
              // this.webCheckProject(this.WebcheckProjectTree)
              // //console.log('testSuiteDirData', testSuiteDirData);
              // //console.log('testSuiteFileData', testSuiteFileData);
              // //console.log('selectedTestSuiteDirData', selectedTestSuiteDirData);

              this.loadSettingTestCases(testSuiteDirData, testSuiteFileData);
            }
            else {
              this.webCheckOuterTestSuite(true, outerSuiteData.id);
            }


          });
        }

      } else {
        this.WebcheckProjectTree = true;
        this.webCheckProject(this.WebcheckProjectTree);
        //console.log('project level');
        //console.log('selectedTestSuiteDirData');

      }
    } else {


    }

    //console.log(data);
    this.selectedAccessor = data.scopeData;
    data.schedulerData.setting.entry.forEach(element => {
      if (element.key == 'time') {
        this.selectedTime = element.value.settingValue;
      }
      else if (element.key == "day") {
        if (element.value) {
          this.selectedDay = element.value.settingValue;
        }
        else {
          this.selectedDay = '';
        }

      }
      else if (element.key == 'frequency') {
        this.selectedFrequency = element.value.settingValue;
      }
      else if (element.key == 'status') {
        if (typeof element.value.settingValue == 'string') {
          this.selectedSchedule = (element.value.settingValue == 'true');
        }
        else {
          this.selectedSchedule = element.value.settingValue;
        }

      }
    });

    //console.log("test : ", this.selectedSchedule, this.selectedDay, this.selectedAccessor, this.selectedFrequency, this.selectedTime);


    // this.webrunsettingdata =  this.webrunsettingtestcaseload[0]['selectedTestSuiteDirData']['testSuiteDirData'][0]['testSuiteFileData'][0]['testCaseData'];

  }

  ngOnInit() {
    this.memoryService.getAgentCheck().subscribe((res)=>
    {
      this.agentCheck = res;
    })
    this.projectId = this.route.snapshot.paramMap.get('pid');
    //console.log(this.projectId);

    this.getProjectTreeData();

    this.project.getProjectById(this.projectId).subscribe((data) => {
      this.projectData = data;
      this.headerOptions.data = {
        projectId: this.projectId,
        projectName: data['projectName']
      };
      //set header details
      this.homeService.setHeaderOptions(this.headerOptions);
      // this.loadSetting(this.projectData.projectName);
      //console.log(" check1 : ", this.projectData);
      // this.getAllChildTestDir(this.projectId);
    })

    this.loadForm();
    this.initEditSettingForm();
    this.http.get(this.url + '/HuLoopRest/huloop/project/' + this.projectId + '/DB?settingName=').subscribe((data) => {
      // //console.log('dbsetting', data);
      this.dbSettingData = data;
      delete this.dbSettingData.projectSettingList[0]['@type'];
      //console.log('dbsetting>>>>', this.dbSettingData.projectSettingList);

    })

    this.http.get(this.url + '/HuLoopRest/huloop/project/' + this.projectId + '/ENV?settingName=mobilSetting').subscribe((data) => {
      this.mobileSettingData = data;
      delete this.mobileSettingData.projectSettingList[0]['@type'];
      //console.log('mobileSetting', this.mobileSettingData.projectSettingList);
    })
    this.http.get(this.url + '/HuLoopRest/huloop/project/' + this.projectId + '/ENV?settingName=desktopSetting').subscribe((data) => {
      this.desktopSettingData = data;
      delete this.desktopSettingData.projectSettingList[0]['@type'];
      //console.log('deskTopSetting', data);
    })
    this.http.get(this.url + '/HuLoopRest/huloop/project/' + this.projectId + '/GLOBAL?settingName=cSetting').subscribe((data) => {
      this.customSettingData = data;
      delete this.customSettingData.projectSettingList[0]['@type'];
      //console.log('customSeeting', this.customSettingData);
    })
    this.http.get(this.url + '/HuLoopRest/huloop/project/' + this.projectId + '/GLOBAL?settingName=gSetting').subscribe((data) => {
      this.globalSettingData = data;
      delete this.globalSettingData.projectSettingList[0]['@type'];
      //console.log('GlobalDataa', data);
    })
    this.http.get(this.url + '/HuLoopRest/huloop/project/' + this.projectId + '/ENV?settingName=envSetting').subscribe((data) => {
      this.testEnvSettingData = data;
      delete this.testEnvSettingData.projectSettingList[0]['@type'];

      //console.log('>>>>>', this.testEnvSettingData);
    })
    if(this.agentCheck)
    {
      this.memoryService.getUrlHistory().subscribe((res)=>
      {
        this.previousUrl =  res;
        if(this.previousUrl.length > 0)
        {
          this.currentUrl =  this.router.url;
          this.previousUrltemp= this.urlService.captureUrl(this.currentUrl);
          this.memoryService.setUrlHistory(this.previousUrltemp);
        }
      })
    }
    else
    {
      this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      if(!this.previousUrl){
        this.currentUrl =  this.router.url;
        this.previousUrltemp= this.urlService.captureUrl(this.currentUrl);
        localStorage.setItem('urlHistory', JSON.stringify(this.previousUrltemp));
        this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      }
    }
  }
  geturlName(url) {
    return this.urlService.geturlName(url);
  }
  initSetting() {
    //console.log("inside init : ", this.webRunSettings4);
    if (this.webRunSettings4) {
      let settingName = this.webRunSettings4[0].settingName;
      this.selectedSettingId = this.webRunSettings4[0].id
      this.loadSetting(settingName);
      let plan = this.webRunSettings4[0].executionPlanList[0];
      //console.log(plan);
      this.getExecutionPlan(plan, 0);
      this.loadSettingProjectTree(settingName);
    }

  }

  loadForm() {
    this.settingForm = this.formBuilder.group({
      settingName: ['', Validators.required]
    })
  }

  initEditSettingForm() {
    this.editSettingForm = this.formBuilder.group({
      settingName: ['', Validators.required]
    })
  }

  get f() { return this.settingForm.controls; }

  trimCommas(str) {
    return str.replace(/^,+|,+$/g, '');
}

onCreateSetting() {
  //  //console.log("project level checked : ", this.checkProjectTree);
  let checkedModules = [];
  let testSuiteFileData = [];
  let isTestCaseSelected: boolean = false;

  if (this.settingForm.invalid) {
    return;
  }
  var objFormval = this.settingForm.value;
  //console.log(objFormval.settingName);
  if (objFormval.settingName.trim().length == 0) {
    this.toastrService.clear();
    this.toastrService.warning("Setting name cannot be empty");
    return;
  }

  //  //console.log('this.webRunSettings ',this.webRunSettings, objFormval);
  //console.log(this.testTreedataDir, this.projectdata[0], this.dbSettingData);

  this.webRunSettings = {};
  this.webRunSettings['projectId'] = this.projectId;
  let dbSettingList = [];
  this.dbSettingData.projectSettingList.forEach(element => {
    dbSettingList.push(_.pick(element, ['name', 'type', 'setting']));
  });
  this.webRunSettings['executionPlanList'] =
    [
      {
        name: 'default',
        testEnvSetting: _.pick(this.testEnvSettingData.projectSettingList[0], ['name', 'type', 'setting']),
        dbSetting: dbSettingList,
        globalSetting: _.pick(this.globalSettingData.projectSettingList[0], ['name', 'type', 'setting']),
        customSetting:  _.pick(this.customSettingData.projectSettingList[0], ['name', 'type', 'setting']),
        mobileSetting:  _.pick(this.mobileSettingData.projectSettingList[0], ['name', 'type', 'setting']),
        desktopSetting: _.pick(this.desktopSettingData.projectSettingList[0], ['name', 'type', 'setting']),
      }
    ];
  this.webRunSettings['schedulerData'] = {
    setting: {
      entry: [
        { key: "frequency", value: { settingValue: "Daily", isMasked: false, maskedValue: "Daily" } },
        { key: "time", value: { settingValue: "12.00 AM", isMasked: false, maskedValue: "12.00 AM" } },
        { key: "day", value: { settingValue: "", isMasked: false, maskedValue: "" } },
        { key: "status", value: { settingValue: "false", isMasked: false, maskedValue: "false" } }
      ]
    }
  }
  this.webRunSettings['settingName'] = objFormval.settingName;
  this.webRunSettings['selectedTestSuiteDirData'] = {
    id: this.projectId,
    selectedState: "INDETERMINATE",
    title: this.projectData.projectName,
    testSuiteFileData: [],
    testSuiteDirData: []
  };

  if (this.checkProjectTree) {
    isTestCaseSelected = true;
    this.testTreedataDir.forEach(element => {
      let obj = {};
      obj['id'] = element.id;
      obj['selectedState'] = 'SELECTED';
      obj['title'] = this.trimCommas(element.title);
      obj['testSuiteDirData'] = [];
      obj['testSuiteFileData'] = [];
      this.webRunSettings['selectedTestSuiteDirData']['selectedState'] = 'SELECTED'
      this.webRunSettings['selectedTestSuiteDirData']['testSuiteDirData'].push(obj);
    });

    this.testTreedata.forEach(element => {
      if (element.path == ',') {
        this.webRunSettings['selectedTestSuiteDirData']['testSuiteFileData'].push(element);
      }
    });

  }
  else {
    //console.log(this.projectdata);
    let moduleObj = {};
    let moduleObj1 = {};
    // let testSuiteObj = {};
    this.projectdata[0].testTreedata.forEach(element => {
      //console.log(element);
      if (element.name == ",") {

        if (element.items) {
          element.items.forEach(content => {
            let obj = {};
            if (content.checked) {
              isTestCaseSelected = true;
              obj['id'] = content.id;
              obj['selectedState'] = "SELECTED";
              obj['title'] = this.trimCommas(content.title);
            }
            else if (content.testCases) {
              let obj1 = [];
              let testCaseChecked1: boolean = false;
              content.testCases.forEach(value1 => {
                if (value1.checked) {
                  isTestCaseSelected = true;
                  testCaseChecked1 = true;
                  let body = {};
                  body['id'] = value1.id;
                  body['selectedState'] = "SELECTED";
                  body['title'] = this.trimCommas(value1.title);
                  obj1.push(body);
                }
              });

              if (testCaseChecked1) {
                obj['id'] = content.id;
                obj['title'] = this.trimCommas(content.title);
                obj['selectedState'] = "INDETERMINATE";
                obj['testCaseData'] = obj1;
              }
            }

            if (Object.keys(obj).length != 0) {
              // childNodesChecked = true;
              testSuiteFileData.push(obj);
            }
          });
        }

      }
      else {
        let childNodesChecked: boolean = false;
        let checkedTestSuites = [];
        if (element.checked) {
          isTestCaseSelected = true;
          moduleObj["id"] = element.id;
          moduleObj["selectedState"] = "SELECTED";
          moduleObj["testSuiteDirData"] = [];
          moduleObj["testSuiteFileData"] = [];
          moduleObj["title"] = this.trimCommas(element.name);
          let moduleData = JSON.parse(JSON.stringify(moduleObj))
          //console.log("before pushing ", moduleData);
          checkedModules.push(moduleData);
          //console.log("after pushing ", checkedModules);
        }
        else {
          element.items.forEach(data => {

            let obj = {};
            if (data.checked) {
              isTestCaseSelected = true;
              obj['id'] = data.id;
              obj['selectedState'] = "SELECTED";
              obj['title'] = this.trimCommas(data.title);
            }
            else if (data.testCases) {
              let obj1 = [];
              let testCaseChecked: boolean = false;
              data.testCases.forEach(value => {
                if (value.checked) {
                  testCaseChecked = true;
                  isTestCaseSelected = true;
                  let body = {};
                  body['id'] = value.id;
                  body['selectedState'] = "SELECTED";
                  body['title'] = this.trimCommas(value.title);
                  obj1.push(body);
                }
              });

              if (testCaseChecked) {
                obj['id'] = data.id;
                obj['title'] = this.trimCommas(data.title);
                obj['selectedState'] = "INDETERMINATE";
                obj['testCaseData'] = obj1;
              }
            }

            if (Object.keys(obj).length != 0) {
              childNodesChecked = true;
              checkedTestSuites.push(obj);
            }

          });
        }

        if (childNodesChecked) {

          moduleObj1["id"] = element.id;
          moduleObj1["selectedState"] = "INDETERMINATE";
          moduleObj1["testSuiteDirData"] = [];
          moduleObj1["testSuiteFileData"] = checkedTestSuites;
          moduleObj1["title"] = this.trimCommas(element.name);
          let moduleData = JSON.parse(JSON.stringify(moduleObj1))
          //console.log("before pushing 2", moduleData);
          checkedModules.push(moduleData);
          //console.log("after pushing 2", checkedModules);
        }
      }



    });
    //console.log(checkedModules);
    this.webRunSettings['selectedTestSuiteDirData']['testSuiteDirData'] = checkedModules;
    this.webRunSettings['selectedTestSuiteDirData']['testSuiteFileData'] = testSuiteFileData;
    this.webRunSettings['selectedTestSuiteDirData']['selectedState'] = 'INDETERMINATE';
  }

  //console.log(isTestCaseSelected);

  if (!isTestCaseSelected) {
    this.toastrService.clear();
    this.toastrService.error("Please select at least one case from your automation using automation tree");
    return;
  }

  //console.log(this.webRunSettings);
  this.project.createRunSettings(this.webRunSettings).subscribe((response) => {
    //console.log(response);
    this.isActiveTab = true;
    this.toastrService.clear();
    this.toastrService.success('Run setting created successfully');
    this.reloadComponent()
    this.resetProjectTree();
    this.loadRunSetting();
    
  })
}
reloadComponent() {
  let currentUrl = this.router.url;
  this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  this.router.onSameUrlNavigation = 'reload';
  this.router.navigate([currentUrl]);
}

  getTestCases(pathdata, parentTestDataId, index) {
    //console.log('pathdata', pathdata, '\nparentTestDataId', parentTestDataId, '\nindex', index);
    let isParentTestSuiteChecked: boolean = false;

    let outerTestSuite: boolean = false;
    if (pathdata.name == ',') {
      outerTestSuite = true;
    }

    let isTestCasesExit: boolean = false;
    this.projectdata[0].testTreedata.forEach(element => {
      if (element.id === pathdata.id) {
        element.items.forEach(element => {
          if (element.id === parentTestDataId) {
            if (element.checked) {
              isParentTestSuiteChecked = element.checked
            }
            if (element.testCases) {
              isTestCasesExit = true
            }
          }
        });
      }
    });

    if (isTestCasesExit) {
      if (outerTestSuite) {
        this.showOuterTestCases(index);
      }
      else {
        this.showTestCases(index);
      }
    }
    else {
      this.http.get(this.url + '/HuLoopRest/huloop/test/testSuiteData/' + this.projectId + '/' + parentTestDataId).subscribe(
        data => {
          this.testCaseTreeData = data['testCaseData'];

          //console.log('testcasedata', this.testCaseTreeData);
          if (outerTestSuite) {
            this.showOuterTestCases(index);
          }
          else {
            this.showTestCases(index);
          }
          this.projectdata[0].testTreedata.forEach(element => {
            if (element.id === pathdata.id) {
              element.items.forEach(element => {
                if (element.id === parentTestDataId) {
                  if (this.testCaseTreeData) {
                    this.testCaseTreeData.forEach(value => {
                      if (element.webChecked) {
                        value.webChecked = element.webChecked;
                      }
                      if (element.checked) {
                        value.checked = element.checked;
                      }
                    });
                  }
                  element.testCases = this.testCaseTreeData;
                }
              });
            }
          });

       //   this.loadSetting(this.settingName);

        }
      )
    }


  }


  expandProject() {
    if (this.projectdata[0].expand) {
      this.projectdata[0].expand = false;
    }
    else {
      this.projectdata[0].expand = true;
    }

    //console.log(this.projectdata)
  }

  settingExpand() {
    if (this.projectdata[0].settingExpand) {
      this.projectdata[0].settingExpand = false;
    }
    else {
      this.projectdata[0].settingExpand = true;
    }

    //console.log(this.projectdata)
  }

  expandSettingModule(pathdata) {

    //console.log('pathdata', pathdata);


    this.projectdata[0].testTreedata.forEach(element => {

      this.visibleOuterTestCaseIndex = -1;
      if (element.id == pathdata.id) {
        if (element.settingExpand) {
          element.settingExpand = false;
        }
        else {
          element.settingExpand = true;
        }
        element.items.forEach(value => {
          value.settingExpand = false;
        });
      }
      else {
        element.settingExpand = false;
        element.items.forEach(value => {
          value.settingExpand = false;
        });
        this.visibleTestCaseIndex = -1

      }
    });
  }

  expandModule(pathdata) {
    this.projectdata[0].testTreedata.forEach(element => {

      this.visibleOuterTestCaseIndex = -1;
      if (element.id == pathdata.id) {
        if (element.expand) {
          element.expand = false;
        }
        else {
          element.expand = true;
        }
        element.items.forEach(value => {
          value.expand = false;
        });
      }
      else {
        element.expand = false;
        element.items.forEach(value => {
          value.expand = false;
        });
        this.visibleTestCaseIndex = -1

      }
    });
  }
  settingTestSuite(pathdata, testSuite) {
    //console.log('pathdata', pathdata, 'testSuite', testSuite);

    this.projectdata[0].testTreedata.forEach(element => {
      if (element.id == pathdata.id) {
        element.items.forEach(value => {
          if (value.id == testSuite.id) {
            if (value.settingExpand) {
              value.settingExpand = false;
            }
            else {
              value.settingExpand = true;
            }
          }
          else {
            value.settingExpand = false;
          }
        });
      }
    });

  }

  expandTestSuite(pathdata, testSuite) {
    //console.log('pathdata', pathdata, 'testSuite', testSuite);

    this.projectdata[0].testTreedata.forEach(element => {
      if (element.id == pathdata.id) {
        element.items.forEach(value => {
          if (value.id == testSuite.id) {
            if (value.expand) {
              value.expand = false;
            }
            else {
              value.expand = true;
            }
          }
          else {
            value.expand = false;
          }
        });
      }
    });
    //console.log(this.projectdata);
  }

  expandOuterTestSuite(pathdata, testSuite) {
    //console.log(pathdata, testSuite);
    this.projectdata[0].testTreedata.forEach(element => {
      element.expand = false;
      element.settingExpand = false;
      this.visibleIndex = -1;
      //console.log("before if")
      if (pathdata.name == ",") {
        //console.log("inside if");
        element.items.forEach(value => {
          if (value.id == testSuite.id) {
            if (value.expand) {
              value.expand = false;

            }
            else {
              value.expand = true;
            }
          }
          if (value.id == testSuite.id) {
            if (value.settingExpand) {
              value.settingExpand = false;

            }
            else {
              value.settingExpand = true;
            }
          }
          else {
            value.expand = false;
            value.settingExpand = true;
          }
        });
      }
    });
    //console.log(this.projectdata);
  }

  // getTestCaseDetails(projectId){
  //   this.http.get(this.url + '/HuLoopRest/huloop/project/'+this.projectId)
  //     .subscribe(data => {
  //       // //console.log('test case details ', data);
  //     })
  // }



  getProjectTreeData() {
    this.project.getAllProjects().subscribe(
      (data) => {
        //console.log('project data', data);
        data['project'].forEach(element => {
          element.expand = false;
          element.settingExpand = false;
        });
        this.projectdata = data['project'];
        //console.log('project data', this.projectdata);
        this.projectdata = this.projectdata.filter((f) => f.id === this.projectId)
        //console.log('[project]', this.projectdata);
        this.loadRunSetting();
        this.getAllChildTestDir(this.projectId);

      });

  }
  sendId(projectId: any) {
    this.project.sendMessage(projectId);
    this.projectId = projectId;
    //console.log(this.projectId);
    this.disableplus = false;
    this.disableminus = true;
  }
  getProjectsById(projectId: any) {
    this.projectId = projectId;
    var respo = this.project.getProjectById(this.projectId)
      .subscribe(
        (data) => {
          this.projectdataById = data;
          //console.log('project by id', this.projectdataById);

        });
    // //console.log( '>>>'+ JSON.stringify(this.projectdataById));
  }

  getTestCasesTest(projectid, parentTestDataId) {
    //console.log(parentTestDataId);
    this.http.get(this.url + '/HuLoopRest/huloop/test/testSuiteData/' + projectid + '/' + parentTestDataId).subscribe(
      data => {
        this.testTreedata = data['testCaseData'];
      }
    )
  }


  getAllChildTestDir(projectId) {
    const params1 = this.projectId;

    //console.log('peojectid', projectId);


    if (this.projectdata != undefined && this.projectdata[0].testTreedata) {
      return;
    }

    var resp = this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/all/' + projectId).
      subscribe(
        (data) => {
          //console.log(data);
          this.testTreedata = data['testSuiteFileData'];
          this.testTreedataDir = data['testSuiteDirData'];

          //console.log('testTreedataDir', this.testTreedataDir)
          //  this.Parent = this.testTreedata[0].parentTestDataId;
          //  //console.log( this.Parent);
          //  //console.log( '[TestTreeData]', this.testTreedata); 
          //console.log("testTreedata", this.testTreedata);




          const projectTestId = this.testTreedata[0] && this.testTreedata[0].projectId;

          //console.log("clicked >", projectTestId);
          // const data = []; //  data from API

          // const moduleTestData = {};

          // this.testTreedata.forEach(function (d) {
          //   if(moduleTestData[d.path]) {
          //     moduleTestData[d.path].push(d)
          //   } else {
          //     moduleTestData[d.path] = [];
          //   }
          // });

          // //console.log(moduleTestData);

          //  //console.log('hello');
          const moduleData = []; // [{name: "a", items: [{}, {}]}, {}]
          const b = {}; // {a: true}
          this.testTreedata.forEach(element => {
            element.checked = false;
          });

          this.testTreedata.forEach(function (d) {
            if (b[d.path]) {
              b[d.path].push(d);
            } else {
              b[d.path] = [];
              b[d.path].push(d);
            }
          });

          console.log("btest : ", b, this.testTreedata);

          Object.entries(b).forEach(([key, value]) => {
            moduleData.push({ name: key, items: value });
          })
          this.moduleData = moduleData;
          //console.log(moduleData);
          this.moduleData.forEach(element => {
            this.testTreedata.forEach(value => {
              if (value.path === element.name) {
                element['id'] = value.parentTestDataId;
                if (this.checkProjectTree) {
                  element['checked'] = true;
                  element.items.forEach(data => {
                    data.checked = true;
                  });
                }
                else {
                  element['checked'] = false;
                }
              }
            });
          });

          //  //console.log('hello end');
          //  this.projectdata = moduleData;
          //  this.projectdata = this.projectdata.map(p => ({ ...p, ...this.testTreedata.find(testData => testData.projectId === p.id) }));

          //console.log('check1', this.projectdata, this.moduleData);
          //console.log('moduledata', this.moduleData);

          this.projectdata = this.projectdata.map(p => ({
            ...p,
            testTreedata: p.id === projectTestId ? this.moduleData : []
          }))



          //console.log('after projectdata', this.projectdata);
        }

      )
  }


  checkProject(checked) {
    this.checkProjectTree = checked;
    //console.log("projectData : ", this.projectdata[0].testTreedata);
    if (this.projectdata[0].testTreedata) {
      this.projectdata[0].testTreedata.forEach(element => {
        element.checked = checked;
        //console.log(element, checked)
        this.checkModule(checked, element);

      });
    }
  }



  webCheckProject(checked) {
    this.WebcheckProjectTree = checked;
    //console.log("projectData : ", this.projectdata);
    if (this.projectdata[0].testTreedata) {
      this.projectdata[0]['webChecked'] = checked;
      this.projectdata[0].testTreedata.forEach(element => {
        element.webChecked = checked;
        //console.log(element, checked)
        this.checkWebModule(checked, element);

      });
    }
  }

  checkWebModule(checked, pathdata) {

    let isAllModulesChecked: boolean = true;
    if (this.projectdata[0].testTreedata) {

      this.projectdata[0].testTreedata.forEach(element => {
        if (element.id === pathdata.id) {
          //console.log(this.projectdata[0])
          element.webChecked = checked;
          element.items.forEach(data => {
            data.webChecked = checked;
            if (data.testCases) {
              data.testCases.forEach(value => {
                value.webChecked = checked;
              });
            }
          });
        }
      });

      this.projectdata[0].testTreedata.forEach(module => {
        if(module.name != ",")
        {
          if (!module.webChecked) {
            isAllModulesChecked = false;
          }
        }
        else
        {
          if(module.items)
          {
              module.items.forEach(element => {
                if(!element.webChecked)
                {
                  isAllModulesChecked = false;
                }
              });
          }
        }
      });

      this.projectdata[0].webChecked = isAllModulesChecked

    }

    // this.checkWebMainProject();


  }

  checkWebMainProject() {
    let iSallModulesChecked: boolean = true;
    this.projectdata[0].testTreedata.forEach(element => {
      if (element.name == ',') {
        element.items.forEach(value => {
          if (!value.webChecked) {
            iSallModulesChecked = false;
          }
        });
      }
      else {
        if (!element.webChecked) {
          iSallModulesChecked = false;
        }
      }

    });
    this.WebcheckProjectTree = iSallModulesChecked;
    this.projectdata[0].webChecked = iSallModulesChecked;
  }

  checkModule(checked, pathdata) {
    if (pathdata.items) {
      this.projectdata[0].testTreedata.forEach(element => {
        if (element.id === pathdata.id) {
          //console.log(this.projectdata[0])
          element.checked = checked;
          element.items.forEach(data => {
            data.checked = checked;
            if (data.testCases) {
              data.testCases.forEach(value => {
                value.checked = checked;
              });
            }
          });
        }
      });

      // let projectCheck = true;
      // this.projectdata[0].testTreedata.forEach(element => {
      //     if(!element.checked)
      //     {
      //       projectCheck = false;
      //     }
      // });
      // this.checkProjectTree = projectCheck;
      this.checkMainProject();
    }

  }

  checkTestSuite(checked, pathdata, id) {
    //console.log("inside ", checked, pathdata, id);
    this.projectdata[0].testTreedata.forEach(element => {
      if (element.id === pathdata.id) {
        // element.checked = checked;
        let checkModule: boolean = true;
        element.items.forEach(data => {
          if (data.id === id) {
            data.checked = checked;
            if (data.testCases) {
              data.testCases.forEach(value => {
                value.checked = checked
              });
            }
          }
        });
        element.items.forEach(data => {
          if (!data.checked) {
            checkModule = false;
          }
        });
        element.checked = checkModule;
        this.checkMainProject();
      }
    });

  }


  webCheckTestSuite(checked, moduleId, testSuiteId) {
    //console.log("inside ", checked, moduleId, testSuiteId);
    // let pathData = {id :  moduleId };
    let pathData;
    let checkTestSuite: boolean = true;

    this.projectdata[0].testTreedata.forEach(element => {

      if (element.id === moduleId) {
        pathData = element;
        element.items.forEach(data => {
          if (data.id === testSuiteId) {
            data.webChecked = checked;
            if (data.testCases) {
              data.testCases.forEach(value => {
                value.webChecked = checked;
              });
            }
          }

          if (!data.webChecked) {
            checkTestSuite = false;
          }

        });
      }

    });

    //console.log(this.projectdata[0]);

    this.checkWebParentModule(checkTestSuite, pathData, testSuiteId);

  }

  webCheckTestCase(checked, moduleId, testSuiteId, testCaseId) {
    //console.log("inside ", checked, moduleId, testSuiteId, testCaseId);
    if(this.projectdata[0].testTreedata)
    {
      this.projectdata[0].testTreedata.forEach(element => {

        if (element.id === moduleId) {
          element.items.forEach(data => {
            if (data.id === testSuiteId) {
              if (data.testCases) {
                data.testCases.forEach(value => {
                  if (value.id === testCaseId) {
                    value.webChecked = checked;
                  }
                });
              }
            }
          });
        }
  
      });
    }




    // this.projectdata[0].testTreedata.forEach(element => {
    //   let name = element.name;
    //   if(element.name != ",")
    //   {
    //     name = element.name.replaceAll(",","")
    //   }
    //   if (name === pathName.name) {
    //     // element.checked = checked;
    //     let checkModule: boolean = true;
    //     element.items.forEach(data => {
    //       if (data.id === id) {
    //         data.webChecked = checked;
    //         if (data.testCases) {
    //           data.testCases.forEach(value => {
    //             value.webChecked = checked
    //           });
    //         }
    //       }
    //     });
    //     element.items.forEach(data => {
    //       if (!data.webChecked) {
    //         checkModule = false;
    //       }
    //     });
    //     element.webChecked = checkModule;
    //     this.checkMainProject();
    //   }
    // });

  }

  webCheckOuterTestSuite(checked, testSuiteId) {

    if (this.projectdata[0].testTreedata) {
      this.projectdata[0].testTreedata.forEach(element => {
        if (element.name === ',') {
          element.items.forEach(data => {
            if (data.id === testSuiteId) {
              data.webChecked = checked;
              if (data.testCases) {
                data.testCases.forEach(value => {
                  value.webChecked = checked;
                });
              }
            }
          });
        }
      });
    }
  }

  webCheckOuterTestCase(checked, testSuiteId, testCaseId) {
    //console.log("inside ", checked, testSuiteId, testCaseId);

    if (this.projectdata[0].testTreedata) {
      this.projectdata[0].testTreedata.forEach(element => {

        if (element.name === ',') {
          element.items.forEach(data => {
            if (data.id === testSuiteId) {
              if (data.testCases) {
                data.testCases.forEach(value => {
                  if (value.id === testCaseId) {
                    value.webChecked = checked;
                  }

                });
              }
            }
          });
        }

      });
    }

  }

  loadTestCaseTreeData(data1, pathdata, parentTestDataId, checked) {
    //console.log(data1, pathdata, parentTestDataId, checked);

    this.projectdata[0].testTreedata.forEach(element => {
      if (element.id === pathdata.id) {
        element.items.forEach(data => {
          if (data.id === parentTestDataId) {
            data.testCases.forEach(value => {
              if (value.id === data1.id) {
                value.checked = checked
              }
            });

            let checkTestSuite: boolean = true;
            data.testCases.forEach(value => {
              if (!value.checked) {
                checkTestSuite = false;
              }
            });

            this.checkParentModule(checkTestSuite, pathdata, parentTestDataId)
            //console.log('checkParentModule', this.checkParentModule);

          }
        });
      }
    });

    //console.log(this.projectdata);
    let obj = {};
    obj['id'] = data1.id;
    obj['title'] = this.trimCommas(data1.title);

    let check: boolean = false;

    this.testCaseList.forEach((e, i) => {
      if (e.id === obj['id']) {
        check = true;
        this.testCaseList.splice(i, 1);
      }
    });

    if (!check) {
      this.testCaseList.push(obj);
    }

  }


  loadTestCaseWebTreeData(data1, pathdata, parentTestDataId, checked) {
    //console.log(data1, pathdata, parentTestDataId, checked);

    this.projectdata[0].testTreedata.forEach(element => {
      if (element.id === pathdata.id) {
        element.items.forEach(data => {
          if (data.id === parentTestDataId) {
            data.testCases.forEach(value => {
              if (value.id === data1.id) {
                value.webChecked = checked
              }
            });

            let checkTestSuite: boolean = true;
            data.testCases.forEach(value => {
              if (!value.webChecked) {
                checkTestSuite = false;
              }
            });

          //  this.webCheckTestSuite(checkTestSuite, pathdata.id, parentTestDataId)
           this.checkWebParentTestSuite(checkTestSuite, pathdata, parentTestDataId)

          }
        });
      }
    });


    let obj = {};
    obj['id'] = data1.id;
    obj['title'] = this.trimCommas(data1.title);

    let check: boolean = false;

    this.testCaseList.forEach((e, i) => {
      if (e.id === obj['id']) {
        check = true;
        this.testCaseList.splice(i, 1);
      }
    });

    if (!check) {
      this.testCaseList.push(obj);
    }

  }

  checkMainProject() {
    let isAllModulesChecked: boolean = true;
    this.projectdata[0].testTreedata.forEach(element => {
      if (element.name == ',') {
        element.items.forEach(value => {
          if (!value.checked) {
            isAllModulesChecked = false;
          }
        });
      }
      else {
        if (!element.checked) {
          isAllModulesChecked = false;
        }
      }

    });
    this.checkProjectTree = isAllModulesChecked;
  }




  checkParentModule(checked, pathdata, TestDataId) {
    this.projectdata[0].testTreedata.forEach(element => {
      if (element.id === pathdata.id) {
        element.items.forEach(data => {
          if (data.id === TestDataId) {
            data.checked = checked;
          }
        });

        let checkModule: boolean = true;
        element.items.forEach(data => {
          if (!data.checked) {
            checkModule = false;
          }
        });

        element.checked = checkModule;
        this.checkMainProject();
      }
    });

  }

  checkWebParentModule(checked, pathdata, TestDataId) {
    let isAllModulesChecked: boolean = true;

    this.projectdata[0].testTreedata.forEach(element => {
      if (element.id === pathdata.id) {
        element.items.forEach(data => {
          if (data.id === TestDataId) {
           // data.webChecked = checked;
          }
        });

        let checkModule: boolean = true;
        element.items.forEach(data => {
          if (!data.webChecked) {
            checkModule = false;
          }
        });

        element.webChecked = checkModule;
        // this.checkWebMainProject();
      }
    });

    this.projectdata[0].testTreedata.forEach(module => {
      if (!module.webChecked) {
        isAllModulesChecked = false;
      }
    });

    this.projectdata[0].webChecked = isAllModulesChecked;
    this.checkWebMainProject();

  }

  checkWebParentTestSuite(checked, pathdata, TestDataId) {
    let isAllModulesChecked: boolean = true;

    this.projectdata[0].testTreedata.forEach(element => {
      if (element.id === pathdata.id) {
        element.items.forEach(data => {
          if (data.id === TestDataId) {
           data.webChecked = checked;
          }
        });

        let checkModule: boolean = true;
        element.items.forEach(data => {
          if (!data.webChecked) {
            checkModule = false;
          }
        });

        element.webChecked = checkModule;
        // this.checkWebMainProject();
      }
    });

    this.projectdata[0].testTreedata.forEach(module => {
      if (!module.webChecked) {
        isAllModulesChecked = false;
      }
    });

    this.projectdata[0].webChecked = isAllModulesChecked;
    this.checkWebMainProject();

  }

  checkOuterTestSuite(checked, pathdata, id) {
    //console.log("inside check")
    this.projectdata[0].testTreedata.forEach(element => {
      if (element.name == ",") {
        element.items.forEach(value => {
          if (value.id == id) {
            value.checked = checked;
            if (value.testCases) {
              value.testCases.forEach(data => {
                data.checked = checked;
              });
            }
          }
        });

        let isAllOuterTestSuitesChecked: boolean = true;
        element.items.forEach(value => {
          if (!value.checked) {
            isAllOuterTestSuitesChecked = false;
          }
        });

        this.checkMainProject();


      }
    });
  }

  checkOuterWebTestSuite(checked, pathdata, id) {
    let isAllModulesChecked: boolean = true;
    this.projectdata[0].testTreedata.forEach(element => {
      if (element.name == ",") {
        element.items.forEach(value => {
          if (value.id == id) {
            value.webChecked = checked;
            if (value.testCases) {
              value.testCases.forEach(data => {
                data.webChecked = checked;
              });
            }
          }
        });

        let isAllOuterTestSuitesChecked: boolean = true;
        element.items.forEach(value => {
          if (!value.webChecked) {
            isAllOuterTestSuitesChecked = false;
          }
        });

        this.checkMainProject();


      }
    });

    this.projectdata[0].testTreedata.forEach(module => {
      if (module.name == ",") {
        module.items.forEach(testSuite => {
          if (!testSuite.webChecked) {
            isAllModulesChecked = false;
          }
        });
      }
      else
      {
        if(!module.webChecked)
        {
          isAllModulesChecked = false;
        }
      }

    });

    //this.checkWebMainProject();
    this.projectdata[0].webChecked = isAllModulesChecked

  }

  checkOuterTestCases(checked, pathdata, testCase) {
    //console.log("inside check")
    this.projectdata[0].testTreedata.forEach(element => {
      if (element.name == ",") {
        element.items.forEach(value => {
          if (value.id == pathdata.id) {
            value.testCases.forEach(data => {
              if (data.id == testCase.id) {
                data.checked = checked;
              }
            });

            let isAllOuterTestSuitesChecked: boolean = true;
            value.testCases.forEach(data => {
              if (!data.checked) {
                isAllOuterTestSuitesChecked = false;
              }
            });
            value.checked = isAllOuterTestSuitesChecked;
            this.checkMainProject();
          }
        });

        // let isAllOuterTestSuitesChecked : boolean = true;
        // element.items.forEach(value => {
        //   if(!value.checked)
        //   {
        //     isAllOuterTestSuitesChecked = false;
        //   }
        // });

        // this.checkMainProject();
      }
    });
    //console.log(this.projectdata);
  }

  checkOuterWebTestCases(checked, pathdata, testCase) {

    let isAllModulesChecked: boolean = true;
    this.projectdata[0].testTreedata.forEach(element => {
      if (element.name == ",") {
        element.items.forEach(value => {
          if (value.id == pathdata.id) {
            value.testCases.forEach(data => {
              if (data.id == testCase.id) {
                data.webChecked = checked;
              }
            });

            let isAllOuterTestSuitesChecked: boolean = true;
            value.testCases.forEach(data => {
              if (!data.webChecked) {
                isAllOuterTestSuitesChecked = false;
              }
            });
            value.webChecked = isAllOuterTestSuitesChecked;
            // this.checkWebMainProject();
          }
        });
      }
    });

    this.projectdata[0].testTreedata.forEach(module => {
      if (module.name == ",") {
        module.items.forEach(testSuite => {
          if (!testSuite.webChecked) {
            isAllModulesChecked = false;
          }
        });
      }
    });
    //this.checkWebMainProject();
    this.projectdata[0].webChecked = isAllModulesChecked
    //console.log(this.projectdata);
  }

  visibleIndex = -1;
  showSubItem(ind) {
    //console.log("showSubItem : ", ind);
    if (this.disableplus2) {
      this.disableplus2 = false;
    }
    else {
      this.disableplus2 = true;
    }

    if (this.disableminus2) {
      this.disableminus2 = false;
    }
    else {
      this.disableminus2 = true;
    }

    if (this.visibleIndex === ind) {
      this.visibleIndex = -1;
    } else {
      this.visibleIndex = ind;
    }
  }

  visibleTestCaseIndex: number = -1;
  showTestCases(ind) {
    this.visibleOuterTestCaseIndex = -1;
    if (this.visibleTestCaseIndex === ind) {
      this.visibleTestCaseIndex = -1;
    } else {
      this.visibleTestCaseIndex = ind;
    }
  }

  visibleOuterTestCaseIndex: number = -1;
  showOuterTestCases(ind) {
    this.visibleTestCaseIndex = -1;
    if (this.visibleOuterTestCaseIndex === ind) {
      this.visibleOuterTestCaseIndex = -1;
    } else {
      this.visibleOuterTestCaseIndex = ind;
    }
  }

  getSettingDatabyId(id) {
    this.settingDataById = this.webRunSettings4.filter((f) => f.id === id);
    //console.log('>>>>', this.settingDataById);
    this.testEnvData = this.settingDataById[0].executionPlanList[0].testEnvSetting.setting.entry;
    this.customData = this.settingDataById[0].executionPlanList[0].customSetting.setting.entry;
    this.appData = this.settingDataById[0].executionPlanList[0].globalSetting.setting.entry;
    this.dbData = this.settingDataById[0].executionPlanList[0].globalSetting.setting.entry;
    //console.log('', this.testEnvData);

  }
  ///HuLoopRest/huloop/webRunSetting/61276c94a1f486a24017af5e/61b1a0da5096cd3148d310f9
  deleteSetting(id, name) {

    this.confirmationDialogService.openConfirmDialog('This will delete the selected Run Setting: ' + name + ' Are you sure you want to proceed?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.http.delete(this.url + '/HuLoopRest/huloop/webRunSetting/' + this.projectId + '/' + id).subscribe(
            (data) => {
              this.project.loadRunSettings(this.projectId).subscribe((data) => {
                //console.log('____________')
                //console.log(data);
                this.webRunSettings4 = data['webRunSetting'];
                if (this.webRunSettings4) {
                  this.selectedSettingId = this.webRunSettings4[0].id;
                  let selectedSetting = this.webRunSettings4.filter((f) => f.id == this.selectedSettingId);
                  this.loadSetting(selectedSetting[0].settingName);
                }

                if (!this.webRunSettings4) {
                  this.createRunSettingTab.nativeElement.click();
                }
                this.toastrService.clear();
                this.toastrService.success('Selected run setting deleted successfully')
                //console.log('____________', this.webRunSettings4)
              });
              //console.log('delete', data)
            }
          )
        }
      });

  }
  AddExecutionPlan(id) {
    //console.log(id)

    this.settingDataById = this.webRunSettings4.filter((f) => f.id === id);
    //console.log(this.settingDataById);

    if (this.settingDataById[0].executionPlanList.length >= 5) {
      this.toastrService.clear();
      this.toastrService.warning("Execution plan limit exhausted for run setting Test");
      return;
    }

    this.ObjforAdd =
    {
      name: 'ExecutionSetting' + this.settingDataById[0].executionPlanList.length,
      testEnvSetting: JSON.parse(JSON.stringify(this.testEnvSettingData.projectSettingList[0])),
      dbSetting: JSON.parse(JSON.stringify(this.dbSettingData.projectSettingList[0])),
      globalSetting: JSON.parse(JSON.stringify(this.globalSettingData.projectSettingList[0])),
      customSetting: JSON.parse(JSON.stringify(this.customSettingData.projectSettingList[0])),
      mobileSetting: JSON.parse(JSON.stringify(this.mobileSettingData.projectSettingList[0])),
      desktopSetting: JSON.parse(JSON.stringify(this.desktopSettingData.projectSettingList[0]))
    }
    //console.log('ObjforAdd', this.ObjforAdd);
    //console.log(this.settingDataById[0].executionPlanList);
    this.settingDataById[0].executionPlanList.push(this.ObjforAdd);
    //console.log(this.settingDataById);

    this.http.put(this.url + '/HuLoopRest/huloop/webRunSetting', this.settingDataById[0]).subscribe((data) => {
      if (data) {

        this.toastrService.clear();
        this.toastrService.success('New execution plan is added.')
        this.isActiveTab = true;
      }
    });

  }

  deleteExecutionPlan(projectId, executionPlanId) {

    this.settingDataById = this.webRunSettings4.filter((f) => f.id === projectId);
    //console.log(this.settingDataById);


    this.settingDataById[0].executionPlanList.splice(executionPlanId, 1);
    //console.log(this.settingDataById);

    this.http.put(this.url + '/HuLoopRest/huloop/webRunSetting', this.settingDataById[0]).subscribe((data) => {
      if (data) {
        this.toastrService.success('Selected execution plan deleted successfully')
        //console.log(data);
        this.isActiveTab = true;
      }
    });
  }

  editSettingName(settingId) {
    this.settingDataById = this.webRunSettings4.filter((f) => f.id === settingId);
    this.editSettingForm.patchValue({
      settingName: this.settingDataById[0].settingName
    })
  }

  onSubmitRenameSetting() {
    let formValue = this.editSettingForm.value;
    if (! /^[^:|*?<>/\\"]+$/.test(formValue.settingName)) {
      this.toastrService.clear();
      this.toastrService.warning('Setting Name is not Valid, Name cannot contain /[<>:"\/\\|?*');
      return;
    }

    let body = JSON.parse(JSON.stringify(this.settingDataById[0]));
    body['settingName'] = formValue.settingName;

    this.http.put(this.url + '/HuLoopRest/huloop/webRunSetting', body).subscribe((data) => {
      if (data) {
        this.toastrService.success('Run setting updated successfully');
        this.cancelEditSettingModal.nativeElement.click();
        this.webRunSettings4.forEach(element => {
          if (element.settingName === this.settingDataById[0].settingName) {
            element.settingName = data['settingName'];
            //console.log(this.webRunSettings4);
          }
        })
      }
    });

  }

  copySetting(settingId) {
    this.settingDataById = this.webRunSettings4.filter((f) => f.id === settingId);
    let body = JSON.parse(JSON.stringify(this.settingDataById[0]));
    body['id'] = null;

    let settingLength =  this.webRunSettings4.length;
    let check = false;
    let settingName = '';

    for(let i=1; i <= settingLength; i++)
    {
        let name = body['settingName'] + "(" + i + ")";
        if(!check)
        {
            let isNameExist = this.webRunSettings4.find((element)=> element['settingName'] == name);
            if(!isNameExist)
            {
              check = true;
              settingName = name;
            }
        }
    }


    body['settingName'] = settingName;
    //console.log(body);
    this.project.createRunSettings(body).subscribe((response) => {
      //console.log(response);
      this.toastrService.clear();
      this.toastrService.success('Run setting copied successfully');
      this.webRunSettings4.splice(0, 0, response);
      this.selectedSettingId = this.webRunSettings4[0].id;
      let selectedSetting = this.webRunSettings4.filter((f) => f.settingName == this.selectedSettingId);
      this.loadSetting(selectedSetting[0].settingName);
      // this.project.loadRunSettings(this.projectId).subscribe((data) => { 
      //   this.webRunSettings4 = data['webRunSetting'];
      // });
    })
  }

  getExecutionPlan(plan, executionPlanId) {
    this.executionPlanName = plan.name
    this.executionPlanIndex = executionPlanId;
    //console.log(plan, executionPlanId);
    this.selectedExecutionPlanId = executionPlanId;
    //console.log(this.webRunSettings4);
    this.selectedSettingTab = 0
    //console.log(plan);
    this.testEnvDataSettingData = plan.testEnvSetting;
    this.applicationSettingData = plan.globalSetting;
    this.customSettingDataforUpdate = plan.customSetting;
    if(plan.dbSetting.length > 0)
    {
      this.dbSettingDataforUpdate = plan.dbSetting[0];
    }
    else
    {
      this.dbSettingDataforUpdate = plan.dbSetting;
    }
    
    //  this.project.getProjectById(sname)
    //   .subscribe(
    //     (data) => {
    //  this.projectSettingData = data;
    //   //console.log(this.projectSettingData.projectSettingList);
    //   this.testEnvDataSettingData = this.projectSettingData.projectSettingList.filter((f)=>f.name=='envSetting');
    //   this.applicationSettingData = this.projectSettingData.projectSettingList.filter((f)=>f.name=='gSetting');
    //   this.customSettingDataforUpdate = this.projectSettingData.projectSettingList.filter((f)=>f.name=='cSetting');

    //   this.dbSettingDataforUpdate = this.projectSettingData.projectSettingList.filter((f)=>f.name=='default');  
    // });
  }

  getSettingDetails(settingName) {
    this.settingName = settingName.settingName;
    this.executionPlanIndex = undefined;
    //console.log(settingName);
    this.selectedAccessor = settingName.scopeData;
    let selectedTime = settingName.schedulerData.setting.entry.filter((data) => {
      if (data.key == 'time') {
        return data.value['settingValue'];
      }
    })
    this.selectedTime = selectedTime[0].value.settingValue;
    let selectedDay = settingName.schedulerData.setting.entry.filter((data) => {
      if (data.key == 'day') {
        return data;
      }
    })

    if (selectedDay[0].value.settingValue == '') {
      this.selectedDay = '';
    }
    else {
      this.selectedDay = selectedDay[0].value.settingValue;
    }


    let selectedFrequency = settingName.schedulerData.setting.entry.filter((data) => {
      if (data.key == 'frequency') {
        return data.value['settingValue'];
      }
    })
    this.selectedFrequency = selectedFrequency[0].value.settingValue;

    let selectedSchedule = settingName.schedulerData.setting.entry.filter((data) => {
      if (data.key == 'status') {
        return data.value['settingValue'];
      }
    })
    let selectedScheduleValue = selectedSchedule[0].value.settingValue;
    this.selectedSchedule = (selectedScheduleValue === 'true');

    //console.log(this.selectedAccessor, this.selectedTime, this.selectedDay, this.selectedFrequency, this.selectedSchedule);
  }

  updateExecutePlan(projectId) {
    //console.log(this.webRunSettings4, projectId);
    this.settingDataById = this.webRunSettings4.filter((f) => f.id === projectId);
    //console.log(this.settingDataById[0]);
    this.settingDataById[0].scopeData = this.selectedAccessor;

    this.settingDataById[0].schedulerData.setting.entry.forEach(data => {
      if (data.key == "time") {
        if(data.value)
        {
          data.value['settingValue'] = this.selectedTime;
          this.settingDataById[0].schedulerData['time'] = data.value;
        }
        else
        {
          data['value'] = {
            settingValue : this.selectedTime
          }
          this.settingDataById[0].schedulerData['time'] = data.value;
        }
        
      }
      else if (data.key == "day") {
       
        if(data.value)
        {
          data.value['settingValue'] = this.selectedDay;
          data.value['maskedValue'] = this.selectedDay;

          this.settingDataById[0].schedulerData['day'] = data.value;

          this.settingDataById[0].schedulerData['day']['settingValue'] = this.dayConvert[this.selectedDay];
          this.settingDataById[0].schedulerData['day']['maskedValue'] = this.dayConvert[this.selectedDay];
        }
        else
        {
          data['value'] = {
            settingValue : this.selectedDay,
            maskedValue : this.selectedDay
          }

          this.settingDataById[0].schedulerData['day'] = data.value;

          this.settingDataById[0].schedulerData['day']['settingValue'] = this.dayConvert[this.selectedDay];
          this.settingDataById[0].schedulerData['day']['maskedValue'] = this.dayConvert[this.selectedDay];

        }
      }
      else if (data.key == "frequency") {
        if(data.value)
        {
          data.value['settingValue'] = this.selectedFrequency;
          this.settingDataById[0].schedulerData['frequency'] = data.value;
        }
        else
        {
          data['value'] = {
            settingValue : this.selectedFrequency
          }
          this.settingDataById[0].schedulerData['frequency'] = data.value;
        }

      }
      else if (data.key == "status") {

        if(data.value)
        {
          data.value['settingValue'] = this.selectedSchedule;
          data.value['maskedValue'] = this.selectedSchedule;
          this.settingDataById[0].schedulerData['status'] = data.value;
        }
        else
        {
          data['value'] = {
            settingValue : this.selectedSchedule,
            maskedValue : this.selectedSchedule
          }

          this.settingDataById[0].schedulerData['status'] = data.value;
        }

      }
      if(data.key != 'frequency' && data.value)
      {
          if(data.value.settingType)
          {
              delete data.value.settingType;
          }
      }
    });
  
    if(this.settingDataById[0].executionPlanList[this.executionPlanIndex].dbSetting.length > 0)
    {
      this.dbSettingDataforUpdate.setting.entry.forEach(element => {
        switch (element.key) {
          case 'server':
            this.settingDataById[0].executionPlanList[this.executionPlanIndex].dbSetting[0].DBServer.settingValue = element.value.settingValue;
            break;
          case 'dbname':
            this.settingDataById[0].executionPlanList[this.executionPlanIndex].dbSetting[0].DBName.settingValue = element.value.settingValue;
            break;
          case 'driver':
            this.settingDataById[0].executionPlanList[this.executionPlanIndex].dbSetting[0].driver.settingValue = element.value.settingValue;
            case 'username':
              this.settingDataById[0].executionPlanList[this.executionPlanIndex].dbSetting[0].user[0].settingValue = element.value.settingValue;
              break;
            case 'password':
              this.settingDataById[0].executionPlanList[this.executionPlanIndex].dbSetting[0].password.settingValue = element.value.settingValue;
              break;
            case 'timezone':
              this.settingDataById[0].executionPlanList[this.executionPlanIndex].dbSetting[0].timezone.settingValue = element.value.settingValue;
              case 'schemaname':
                this.settingDataById[0].executionPlanList[this.executionPlanIndex].dbSetting[0].schemaName.settingValue = element.value.settingValue;
            break;
          default:
            break;
        }
       
      });
      
    }
    else
    {
      this.dbSettingDataforUpdate.setting.entry.forEach(element => {
        switch (element.key) {
          case 'server':
            this.settingDataById[0].executionPlanList[this.executionPlanIndex].dbSetting.DBServer.settingValue = element.value.settingValue;
            break;
          case 'dbname':
            this.settingDataById[0].executionPlanList[this.executionPlanIndex].dbSetting.DBName.settingValue = element.value.settingValue;
            break;
          case 'driver':
            this.settingDataById[0].executionPlanList[this.executionPlanIndex].dbSetting.driver.settingValue = element.value.settingValue;
            case 'username':
              this.settingDataById[0].executionPlanList[this.executionPlanIndex].dbSetting.user[0].settingValue = element.value.settingValue;
              break;
            case 'password':
              this.settingDataById[0].executionPlanList[this.executionPlanIndex].dbSetting.password.settingValue = element.value.settingValue;
              break;
            case 'timezone':
              this.settingDataById[0].executionPlanList[this.executionPlanIndex].dbSetting.timezone.settingValue = element.value.settingValue;
              case 'schemaname':
                this.settingDataById[0].executionPlanList[this.executionPlanIndex].dbSetting.schemaName.settingValue = element.value.settingValue;
            break;
          default:
            break;
        }
       
      });
    }
  

    // this.settingDataById[0].executionPlanList[0].dbSetting.DBName.settingValue = "Ashutosh123";

    this.http.put(this.url + '/HuLoopRest/huloop/webRunSetting', this.settingDataById[0]).subscribe((data) => {
      if (data) {
        //console.log('update plan', data);
        this.isActiveTab = true;
        this.toastrService.success('Selected execution plan updated successfully')
      }
    });
  }

  updateScheduleSetting(index) {
    //console.log(this.webRunSettings4, index);
    //console.log(this.webRunSettings4[index]);
    //console.log(this.selectedSchedule);
    let isTestCaseSelected: boolean = false;
    this.webRunSettings4[index].scopeData = this.selectedAccessor;

    this.webRunSettings4[index].schedulerData.setting.entry.forEach((data) => {
    //  //console.log(data);
      if (data.key == "time") {
        if(data.value)
        {
          data.value['settingValue'] = this.selectedTime;
          this.webRunSettings4[index].schedulerData['time'] = data.value;
        }
        else
        {
          data['value'] = {
            settingValue : this.selectedTime
          }
          this.webRunSettings4[index].schedulerData['time'] = data.value;
        }
        
      }
      else if (data.key == "day") {
       
        if(data.value)
        {
          data.value['settingValue'] = this.selectedDay;
          data.value['maskedValue'] = this.selectedDay;

          this.webRunSettings4[index].schedulerData['day'] = data.value;

         this.webRunSettings4[index].schedulerData['day']['settingValue'] = this.dayConvert[this.selectedDay];
         this.webRunSettings4[index].schedulerData['day']['maskedValue'] = this.dayConvert[this.selectedDay];
        }
        else
        {
          data['value'] = {
            settingValue : this.selectedDay,
            maskedValue : this.selectedDay
          }

          this.webRunSettings4[index].schedulerData['day'] = data.value;

          this.webRunSettings4[index].schedulerData['day']['settingValue'] = this.dayConvert[this.selectedDay];
          this.webRunSettings4[index].schedulerData['day']['maskedValue'] = this.dayConvert[this.selectedDay];

        }
      }
      else if (data.key == "frequency") {
        if(data.value)
        {
          data.value['settingValue'] = this.selectedFrequency;
          this.webRunSettings4[index].schedulerData['frequency'] = data.value;
        }
        else
        {
          data['value'] = {
            settingValue : this.selectedFrequency
          }
          this.webRunSettings4[index].schedulerData['frequency'] = data.value;
        }

      }
      else if (data.key == "status") {

        if(data.value)
        {
          data.value['settingValue'] = this.selectedSchedule;
          data.value['maskedValue'] = this.selectedSchedule;
          this.webRunSettings4[index].schedulerData['status'] = data.value;
        }
        else
        {
          data['value'] = {
            settingValue : this.selectedSchedule,
            maskedValue : this.selectedSchedule
          }

          this.webRunSettings4[index].schedulerData['status'] = data.value;
        }

      }
      if(data.key != 'frequency' && data.value)
      {
          if(data.value.settingType)
          {
              delete data.value.settingType;
          }
      }
    })


    let checkedModules = [];
    let testSuiteFileData = [];

    //console.log(this.projectdata);


    if (this.projectdata[0].webChecked) {
      isTestCaseSelected = true;
      this.webRunSettings4[index]['selectedTestSuiteDirData']['testSuiteDirData']=[];
      this.testTreedataDir.forEach(element => {
        let obj = {};
        obj['id'] = element.id;
        obj['selectedState'] = 'SELECTED';
        obj['title'] = this.trimCommas(element.title);
        obj['testSuiteDirData'] = [];
        obj['testSuiteFileData'] = [];
        this.webRunSettings4[index]['selectedTestSuiteDirData']['selectedState'] = 'SELECTED'
        this.webRunSettings4[index]['selectedTestSuiteDirData']['testSuiteDirData'].push(obj);
      });

      this.testTreedata.forEach(element => {
        if (element.path == ',') {
          if( this.webRunSettings4[index]['selectedTestSuiteDirData']['testSuiteFileData'])
          {
            this.webRunSettings4[index]['selectedTestSuiteDirData']['testSuiteFileData'].push(element);
          }
          else{
            this.webRunSettings4[index]['selectedTestSuiteDirData']['testSuiteFileData'] = [];
            this.webRunSettings4[index]['selectedTestSuiteDirData']['testSuiteFileData'].push(element);
          }
          
        }
      });

    }
    else {
      //console.log(this.projectdata);
      let moduleObj = {};
      let moduleObj1 = {};
      // let testSuiteObj = {};
      this.projectdata[0].testTreedata.forEach(element => {
        //console.log(element);
        if (element.name == ",") {
          element.items.forEach(content => {
            let obj = {};
            if (content.webChecked) {
              isTestCaseSelected = true;
              obj['id'] = content.id;
              obj['selectedState'] = "SELECTED";
              obj['title'] = this.trimCommas(content.title);
            }
            else if (content.testCases) {
              let obj1 = [];
              let testCaseChecked1: boolean = false;
              content.testCases.forEach(value1 => {
                if (value1.webChecked) {
                  isTestCaseSelected = true;
                  testCaseChecked1 = true;
                  let body = {};
                  body['id'] = value1.id;
                  body['selectedState'] = "SELECTED";
                  body['title'] = this.trimCommas(value1.title);
                  obj1.push(body);
                }
              });

              if (testCaseChecked1) {
                obj['id'] = content.id;
                obj['title'] = this.trimCommas(content.title);
                obj['selectedState'] = "INDETERMINATE";
                obj['testCaseData'] = obj1;
              }
            }

            if (Object.keys(obj).length != 0) {
              // childNodesChecked = true;
              testSuiteFileData.push(obj);
            }
          });
        }
        else {
          let childNodesChecked: boolean = false;
          let checkedTestSuites = [];
          if (element.webChecked) {
            isTestCaseSelected = true;
            moduleObj["id"] = element.id;
            moduleObj["selectedState"] = "SELECTED";
            moduleObj["testSuiteDirData"] = [];
            moduleObj["testSuiteFileData"] = [];
            moduleObj["title"] = this.trimCommas(element.name);
            let moduleData = JSON.parse(JSON.stringify(moduleObj))
            //console.log("before pushing ", moduleData);
            checkedModules.push(moduleData);
            //console.log("after pushing ", checkedModules);
          }
          else {
            element.items.forEach(data => {
              let obj = {};
              if (data.webChecked) {
                isTestCaseSelected = true;
                obj['id'] = data.id;
                obj['selectedState'] = "SELECTED";
                obj['title'] = this.trimCommas(data.title);
              }
              else if (data.testCases) {
                let obj1 = [];
                let testCaseChecked: boolean = false;
                data.testCases.forEach(value => {
                  if (value.webChecked) {
                    testCaseChecked = true;
                    isTestCaseSelected = true;
                    let body = {};
                    body['id'] = value.id;
                    body['selectedState'] = "SELECTED";
                    body['title'] = this.trimCommas(value.title);
                    obj1.push(body);
                  }
                });

                if (testCaseChecked) {
                  obj['id'] = data.id;
                  obj['title'] = this.trimCommas(data.title);
                  obj['selectedState'] = "INDETERMINATE";
                  obj['testCaseData'] = obj1;
                }
              }

              if (Object.keys(obj).length != 0) {
                childNodesChecked = true;
                checkedTestSuites.push(obj);
              }

            });
          }

          if (childNodesChecked) {

            moduleObj1["id"] = element.id;
            moduleObj1["selectedState"] = "INDETERMINATE";
            moduleObj1["testSuiteDirData"] = [];
            moduleObj1["testSuiteFileData"] = checkedTestSuites;
            moduleObj1["title"] = this.trimCommas(element.name);
            let moduleData = JSON.parse(JSON.stringify(moduleObj1))
            //console.log("before pushing 2", moduleData);
            checkedModules.push(moduleData);
            //console.log("after pushing 2", checkedModules);
          }
        }

      });
      //console.log(checkedModules);
      this.webRunSettings4[index]['selectedTestSuiteDirData']['testSuiteDirData'] = checkedModules;
      this.webRunSettings4[index]['selectedTestSuiteDirData']['testSuiteFileData'] = testSuiteFileData;
      this.webRunSettings4[index]['selectedTestSuiteDirData']['selectedState'] = 'INDETERMINATE';
    }

    //console.log(isTestCaseSelected);

    if (!isTestCaseSelected) {
      this.toastrService.clear();
      this.toastrService.error("Please select at least one case from your automation using automation tree");
      return;
    }
    console.log('dataWeb',this.webRunSettings4[index]);
    if(this.webRunSettings4[index].executionPlanList.length>1){
  for (let i = 0; i < this.webRunSettings4[index].executionPlanList.length; i++) {
   
    if(this.webRunSettings4[index].executionPlanList[i].dbSetting.length > 0)
    {
      this.webRunSettings4[index].executionPlanList[i].dbSetting[i].setting.entry.forEach(element => {
        switch (element.key) {
          case 'server':
            this.webRunSettings4[index].executionPlanList[i].dbSetting[i].DBServer.settingValue = element.value.settingValue;
            break;
          case 'dbname':
            this.webRunSettings4[index].executionPlanList[i].dbSetting[i].DBName.settingValue = element.value.settingValue;
            break;
          case 'driver':
            this.webRunSettings4[index].executionPlanList[i].dbSetting[i].driver.settingValue = element.value.settingValue;
            case 'username':
              this.webRunSettings4[index].executionPlanList[i].dbSetting[i].user[0].settingValue = element.value.settingValue;
              break;
            case 'password':
              this.webRunSettings4[index].executionPlanList[i].dbSetting[i].password.settingValue = element.value.settingValue;
              break;
            case 'timezone':
              this.webRunSettings4[index].executionPlanList[i].dbSetting[i].timezone.settingValue = element.value.settingValue;
              case 'schemaname':
                this.webRunSettings4[index].executionPlanList[i].dbSetting[i].schemaName.settingValue = element.value.settingValue;
            break;
          default:
            break;
        }
       
      });
      
    }
    else
    {
      this.webRunSettings4[index].executionPlanList[i].dbSetting.setting.entry.forEach(element => {
        switch (element.key) {
          case 'server':
            this.webRunSettings4[index].executionPlanList[i].dbSetting.DBServer.settingValue = element.value.settingValue;
            break;
          case 'dbname':
            this.webRunSettings4[index].executionPlanList[i].dbSetting.DBName.settingValue = element.value.settingValue;
            break;
          case 'driver':
            this.webRunSettings4[index].executionPlanList[i].dbSetting.driver.settingValue = element.value.settingValue;
            case 'username':
              this.webRunSettings4[index].executionPlanList[i].dbSetting.user[0].settingValue = element.value.settingValue;
              break;
            case 'password':
              this.webRunSettings4[index].executionPlanList[i].dbSetting.password.settingValue = element.value.settingValue;
              break;
            case 'timezone':
              this.webRunSettings4[index].executionPlanList[i].dbSetting.timezone.settingValue = element.value.settingValue;
              case 'schemaname':
                this.webRunSettings4[index].executionPlanList[i].dbSetting.schemaName.settingValue = element.value.settingValue;
            break;
          default:
            break;
        }
       
      });
    }
  }
}
    else if(this.webRunSettings4[index].executionPlanList.length==1){
    if(this.webRunSettings4[index].executionPlanList[0].dbSetting.length > 0)
    {
      for (let j = 0; j < this.webRunSettings4[index].executionPlanList[0].dbSetting.length; j++) {
        
      this.webRunSettings4[index].executionPlanList[0].dbSetting[j].setting.entry.forEach(element => {
        switch (element.key) {
          case 'server':
            this.webRunSettings4[index].executionPlanList[0].dbSetting[j].DBServer.settingValue = element.value.settingValue;
            break;
          case 'dbname':
            this.webRunSettings4[index].executionPlanList[0].dbSetting[j].DBName.settingValue = element.value.settingValue;
            break;
          case 'driver':
            this.webRunSettings4[index].executionPlanList[0].dbSetting[j].driver.settingValue = element.value.settingValue;
            case 'username':
              this.webRunSettings4[index].executionPlanList[0].dbSetting[j].user[0].settingValue = element.value.settingValue;
              break;
            case 'password':
              this.webRunSettings4[index].executionPlanList[0].dbSetting[j].password.settingValue = element.value.settingValue;
              break;
            case 'timezone':
              this.webRunSettings4[index].executionPlanList[0].dbSetting[j].timezone.settingValue = element.value.settingValue;
              case 'schemaname':
                this.webRunSettings4[index].executionPlanList[0].dbSetting[j].schemaName.settingValue = element.value.settingValue;
            break;
          default:
            break;
        }
       
      });
        
      }

      
    }
    else
    {
      this.webRunSettings4[index].executionPlanList[0].dbSetting.setting.entry.forEach(element => {
        switch (element.key) {
          case 'server':
            this.webRunSettings4[index].executionPlanList[0].dbSetting.DBServer.settingValue = element.value.settingValue;
            break;
          case 'dbname':
            this.webRunSettings4[index].executionPlanList[0].dbSetting.DBName.settingValue = element.value.settingValue;
            break;
          case 'driver':
            this.webRunSettings4[index].executionPlanList[0].dbSetting.driver.settingValue = element.value.settingValue;
            case 'username':
              this.webRunSettings4[index].executionPlanList[0].dbSetting.user[0].settingValue = element.value.settingValue;
              break;
            case 'password':
              this.webRunSettings4[index].executionPlanList[0].dbSetting.password.settingValue = element.value.settingValue;
              break;
            case 'timezone':
              this.webRunSettings4[index].executionPlanList[0].dbSetting.timezone.settingValue = element.value.settingValue;
              case 'schemaname':
                this.webRunSettings4[index].executionPlanList[0].dbSetting.schemaName.settingValue = element.value.settingValue;
            break;
          default:
            break;
        }
       
      });
    }
  
    }
    this.http.put(this.url + '/HuLoopRest/huloop/webRunSetting', this.webRunSettings4[index]).subscribe((data) => {
      if (data) {
        //console.log(data);
        this.isActiveTab = true;
        this.toastrService.success('Selected execution plan updated successfully')
      }
    });
  }


  loadSettingProjectTree(settingName: string) {
    //console.log('test', settingName);
    this.webrunsettingtestcaseload = this.webRunSettings4.filter((f) => f.settingName == settingName);
    this.webrunsettingdata = this.webrunsettingtestcaseload[0];
    //console.log("test", this.webrunsettingdata);
    //console.log("test ", this.projectdata);
  }

  onFrequencyChange(event) {
    //console.log(event);
    this.selectedDay = "";
    this.selectedTime = "";
  }

  resetProjectTree() {
    this.checkProject(false);
    this.settingForm.reset();
    // this.webCheckProject(false);
    this.visibleTestCaseIndex = - 1;
    this.visibleIndex = -1;
    this.visibleOuterTestCaseIndex = -1;
    this.projectdata.forEach((projectData) => {
      projectData['expand'] = false;
      projectData['settingExpand'] = false;
      if (projectData.testTreedata) {
        projectData.testTreedata.forEach(moduleData => {
          moduleData['expand'] = false;
          moduleData['settingExpand'] = false;
          if (moduleData.items) {
            moduleData.items.forEach(testSuiteData => {
              testSuiteData['expand'] = false;
              testSuiteData['settingExpand'] = false;
            });
          }
        });
      }
    })
  }

  loadFirstProject() {
    let selectedSetting = this.webRunSettings4.filter((f) => f.id == this.selectedSettingId);
    this.loadSetting(selectedSetting[0].settingName);
  }

}
